import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { fromTo } from "utils/misc";
import { useAppointmentLogic } from "components/upcoming-chats/use-appointment-logic";
import useTranslate from "hooks/use-translate-language";
import ClockIcon from "assets/images/clock_gray.png";

const ChatHistoryMobileCard = ({ chats, master_chat_type }) => {
  const translate = useTranslate();
  const {
    speaksSpanish,
    browserTimezone,
    chat_details,
    topic_details,
    startTimeFromCSTToBrowser,
    endTimeFromCSTToBrowser
  } = useAppointmentLogic(chats, master_chat_type);

  // Build comprehensive aria-label for screen readers
  const appointmentDate = moment(chat_details.date_time).format("MMMM DD, yyyy");
  const appointmentTime = `${fromTo(
    startTimeFromCSTToBrowser,
    endTimeFromCSTToBrowser,
    translate("to")
  )} ${moment.tz(browserTimezone).format("z")}`;
  const topicName = !speaksSpanish
    ? topic_details[0]?.topic_name
    : topic_details[0]?.spanish_topic_name ?? topic_details[0]?.topic_name;
  const appointmentType = translate(master_chat_type);
  const providerName = chat_details.dme_details?.name;

  const ariaLabel = `${translate("appointment")}: ${topicName}, ${appointmentType}. ${translate("date")}: ${appointmentDate}, ${appointmentTime}. ${translate("with")}: ${providerName}`;

  return (
    <article className="upcoming-chat-mobile-card" tabIndex={0} role="article" aria-label={ariaLabel}>
      <div className="mobile-card-header">
        <div className="mobile-card-left-container">
          <div className="mobile-card-date-time">
            <img src={ClockIcon} alt="" aria-hidden="true" />
            <div className="date-time-content">
              <h3 className="mobile-card-heading">
                {`${moment(chat_details.date_time).format("DD")}, ${moment(
                  chat_details.date_time
                ).format("MMMM")} ${moment(chat_details.date_time).format(
                  "yyyy"
                )}`}
              </h3>
              <div className="time-range">
                {`${fromTo(
                  startTimeFromCSTToBrowser,
                  endTimeFromCSTToBrowser,
                  translate("to")
                )} (${moment.tz(browserTimezone).format("z")})`}
              </div>
            </div>
          </div>
        </div>
        <div className="mobile-card-right-container">
          <div>
            <h4 className="mobile-card-topic-heading">{`${
              !speaksSpanish
                ? topic_details[0]?.topic_name
                : topic_details[0]?.spanish_topic_name ??
                  topic_details[0]?.topic_name
            }`}</h4>
            {` | `}
            <span style={{ whiteSpace: "nowrap" }}>
              {`${translate(master_chat_type)}`}
            </span>
          </div>

          <div>
            <div>{translate("with")}</div>
            <div>{chat_details.dme_details?.name}</div>
          </div>
        </div>
      </div>
    </article>
  );
};

ChatHistoryMobileCard.propTypes = {
  chats: PropTypes.arrayOf(PropTypes.object),
  master_chat_type: PropTypes.string
};

export default ChatHistoryMobileCard;
